// extracted by mini-css-extract-plugin
export default {"grid":"TrendingSection_grid__Pdyk6","loadMoreBtn":"TrendingSection_loadMoreBtn__P2-lP"};